<template>
  <div class="container">
    <img src="../assets/bg1.png" class="bg" />
    <img src="../assets/logo2.gif" alt="GIF 图片" class="logo-gif" />

    <div class="box">
      <div class="item-box">
        <div
          class="item"
          v-for="(item, index) in list"
          v-on:click="clickItem(item)"
          :key="index"
        >
          <img :src="item.link" class="cover" />
          <img src="../assets/play_icon.png" class="play-icon" />
        </div>
      </div>
      <div class="item-box-2">
        <div
          class="item"
          v-for="(item, index) in list2"
          v-on:click="clickItem(item)"
          :key="index"
        >
          <img :src="item.link" class="cover" />
          <img src="../assets/play_icon.png" class="play-icon" />
        </div>
      </div>
    </div>
    <div v-show="showMask">
      <div :class="isPC() ? 'pc-mask' : 'mask'">
        <div class="close" v-on:click="close()">
          <img src="../assets/close-icon.png" />
        </div>
        <div class="center">
          <div v-for="(item, index) in list" :key="index">
            <video
              style="object-fit: cover"
              @play="videoPlay"
              :id="url"
              v-if="item.url == url"
              :class="isPC() ? 'video-js  pc-video' : 'video-js video'"
              :poster="link"
              controls
            >
              <source :src="url" type="video/mp4" />
            </video>
          </div>
          <div v-for="(item, index) in list2" :key="index">
            <video
              style="object-fit: cover"
              @play="videoPlay"
              :id="url"
              v-if="item.url == url"
              :class="isPC() ? 'video-js  pc-video' : 'video-js video'"
              :poster="link"
              controls
            >
              <source :src="url" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMask: false,
      currentPlayer: null,
      player: null,
      link: "",
      url: "https://recruit-zj.oss-cn-beijing.aliyuncs.com/video/2024-3-21.mp4",
      list: [
        {
          link: "https://recruit.yunquancn.com/video/WechatIMG109.jpg",
          url: "https://recruit.yunquancn.com/video/30_1715147136.mp4",
        },
        {
          link: "https://recruit-zj.oss-cn-beijing.aliyuncs.com/video/20240321-1.jpg",
          url: "https://recruit.yunquancn.com/video/3cc6f4cf21611a9ced13f5acc3f8940e.mp4",
        },
        {
          link: "https://recruit-zj.oss-cn-beijing.aliyuncs.com/video/20240321-2.jpg",
          url: "https://recruit.yunquancn.com/video/5f0f8a031bda847d3519d45495bc89fb.mp4",
        },
      ],
      list2: [
        {
          link: "https://recruit-zj.oss-cn-beijing.aliyuncs.com/video/20240321-5.jpg",
          url: "https://recruit.yunquancn.com/video/60e82d261b16c8670dad886fcb9a0550.mp4",
        },
        {
          link: "https://recruit-zj.oss-cn-beijing.aliyuncs.com/video/20240321-3.jpg",
          url: "https://recruit.yunquancn.com/video/%E9%A3%9E%E4%B9%A620240402-140835.mp4",
        },
        {
          link: "https://recruit-zj.oss-cn-beijing.aliyuncs.com/video/20240321-4.jpg",
          url: "https://recruit.yunquancn.com/video/%E6%B8%85%E5%BB%89%E5%B1%85_1711373637364292.mp4",
        },
      ],
      options: {
        autoplay: true, // 设置自动播放
        controls: false, // 显示播放控件
      },
    };
  },
  name: "SchoolInfoPage",
  mounted() {
    window.addEventListener("scroll", this.scroll, false);
    // this.player = this.$video(url, this.options);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scroll); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    isPC() {
      let userAgentInfo = navigator.userAgent; // 包含有关浏览器的信息
      // 非手机端
      let Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      let flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    close() {
      this.showMask = false;
      if (this.currentPlayer && this.currentPlayer !== event.target) {
        this.currentPlayer.pause();
      }
    },
    clickItem(item) {
      this.url = item.url;
      this.link = item.link;
      this.showMask = true;
      console.log(">>>>>", this.url);
      //  this.initVideo()
    },
    videoPlay(event) {
      if (this.currentPlayer && this.currentPlayer !== event.target) {
        this.currentPlayer.pause();
      }
      this.currentPlayer = event.target;
    },
    initVideo() {
      this.currentPlayer = this.$video(this.url, {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: "muted",
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        //设置视频播放器的显示宽度（以像素为单位）
        width: "500px",
        //设置视频播放器的显示高度（以像素为单位）
        height: "300px",
        //封面图
      });
    },
    scroll() {},
  },
};
</script>

<style scoped>
.container {
  position: relative;
  padding: 0;
  background-size: contain ｜ cover;
  width: 100%;
  height: auto;
}

.logo-gif {
  position: absolute;
  left: 0.5rem;
  top: 1rem;
  width: 1.5rem;
  height: 1.5rem;
}

.box {
  position: absolute;
  left: 0;
  right: 0;
  top: 7.5rem;
  width: 100%;
  height: 200px;
}

.item-box {
  display: flex;
  justify-content: space-between;
  margin-right: 0.3rem;
}

.item-box-2 {
  padding-top: 0.3rem;
  display: flex;
  justify-content: space-between;
  margin-right: 0.3rem;
}

.item2 {
  flex: 1;
  height: 1.4rem;
  border-radius: 0.16rem;
  position: relative;
}

.cover {
  width: 100%;
  height: 100%;
  border-radius: 0.16rem;
}

.play-icon {
  width: 0.58rem;
  height: 0.58rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.on {
  margin-left: 0.3rem;
}

.item {
  flex: 1;
  height: 1.4rem;
  margin-left: 0.3rem;
  border-radius: 0.16rem;
  position: relative;
}

.bg {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  padding: 0;
  width: 100%;
  height: 15rem;
}

.video {
  width: 100%;
  height: auto;
  max-height: 10rem;
}
.pc-video {
  width: 100%;
  height: auto;
  max-height: 1800px;
}

.video::-webkit-media-controls-fullscreen-button {
  display: none;
}

.center {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.close {
  color: #fff;
  position: absolute;
  top: 1.7rem;
  right: 0.3rem;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  width: 100%;
  height: 15rem;
  background: rgba(0, 0, 0, 0.6);
}
.pc-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  width: 100%;
  height: 15rem;
  background: rgba(0, 0, 0, 0.6);
}
</style>



// WEBPACK FOOTER //
// src/components/SchoolInfoPage.vue